/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlock } from './DatabaseHeaderBlock';
import {
    DatabaseHeaderBlockFromJSON,
    DatabaseHeaderBlockFromJSONTyped,
    DatabaseHeaderBlockToJSON,
} from './DatabaseHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseTextHeaderBlock
 */
export interface DatabaseTextHeaderBlock extends DatabaseHeaderBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    fontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseTextHeaderBlock
     */
    fontSize?: DatabaseFontSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    fontColor?: string;
    /**
     * "Auf eine Zeile schrumpfen" — der Text wird so weit verkleinert, dass er OHNE UMBRUCH in den Baustein passt.
     * WAS OHNE DIESEN SCHALTER GESCHIEHT: Der Text verkleinert sich nur so weit, bis er in die HOEHE des Bausteins passt; umbrechen darf er dabei. Eine Kopfzeile wie "ANRUFEN - ABHOLEN - ZEIT SPAREN" rutscht in einem schmalen Baustein also auf zwei Zeilen.
     * WARUM ALS SCHALTER UND NICHT AUTOMATISCH: Es gab diese Automatik schon einmal (`96c47aa3`) — zugeschnitten auf genau eine Ueberschrift. Sie wurde entfernt (`3f3c3c25`), weil an Inhalte gekoppeltes Verhalten in dieser Anwendung immer falsch liegt: Was fuer den einen Text richtig ist, zerreisst den naechsten. Jetzt entscheidet der Betreiber je Baustein.
     * Fehlt der Wert, wird umgebrochen — das bisherige Verhalten. Bestehende Bausteine veraendern sich also nicht von selbst.
     * @type {boolean}
     * @memberof DatabaseTextHeaderBlock
     */
    shrinkToSingleLine?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    textShadowColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseTextHeaderBlock
     */
    textShadowX?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseTextHeaderBlock
     */
    textShadowY?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseTextHeaderBlock
     */
    textShadowBlur?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    textStrokeColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseTextHeaderBlock
     */
    textStrokeWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    textGradientColor1?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    textGradientColor2?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseTextHeaderBlock
     */
    textGradientAngle?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextHeaderBlock
     */
    textBackgroundImageId?: string;
}

/**
 * Check if a given object implements the DatabaseTextHeaderBlock interface.
 */
export function instanceOfDatabaseTextHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTextHeaderBlockFromJSON(json: any): DatabaseTextHeaderBlock {
    return DatabaseTextHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseTextHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTextHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : json['content'],
        'fontFamily': !exists(json, 'fontFamily') ? undefined : json['fontFamily'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'shrinkToSingleLine': !exists(json, 'shrinkToSingleLine') ? undefined : json['shrinkToSingleLine'],
        'textShadowColor': !exists(json, 'textShadowColor') ? undefined : json['textShadowColor'],
        'textShadowX': !exists(json, 'textShadowX') ? undefined : json['textShadowX'],
        'textShadowY': !exists(json, 'textShadowY') ? undefined : json['textShadowY'],
        'textShadowBlur': !exists(json, 'textShadowBlur') ? undefined : json['textShadowBlur'],
        'textStrokeColor': !exists(json, 'textStrokeColor') ? undefined : json['textStrokeColor'],
        'textStrokeWidth': !exists(json, 'textStrokeWidth') ? undefined : json['textStrokeWidth'],
        'textGradientColor1': !exists(json, 'textGradientColor1') ? undefined : json['textGradientColor1'],
        'textGradientColor2': !exists(json, 'textGradientColor2') ? undefined : json['textGradientColor2'],
        'textGradientAngle': !exists(json, 'textGradientAngle') ? undefined : json['textGradientAngle'],
        'textBackgroundImageId': !exists(json, 'textBackgroundImageId') ? undefined : json['textBackgroundImageId'],
    };
}

export function DatabaseTextHeaderBlockToJSON(value?: DatabaseTextHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseHeaderBlockToJSON(value),
        'content': value.content,
        'fontFamily': value.fontFamily,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
        'fontColor': value.fontColor,
        'shrinkToSingleLine': value.shrinkToSingleLine,
        'textShadowColor': value.textShadowColor,
        'textShadowX': value.textShadowX,
        'textShadowY': value.textShadowY,
        'textShadowBlur': value.textShadowBlur,
        'textStrokeColor': value.textStrokeColor,
        'textStrokeWidth': value.textStrokeWidth,
        'textGradientColor1': value.textGradientColor1,
        'textGradientColor2': value.textGradientColor2,
        'textGradientAngle': value.textGradientAngle,
        'textBackgroundImageId': value.textBackgroundImageId,
    };
}

